import type { ReactNode } from 'react';

/**
 * The screen's hero card. DESIGN.md §8.2.
 *
 * One per screen, max. Glass surface tinted with the active theme's hero
 * color, frosted backdrop blur, top-edge sheen, two-layer hero glow
 * radiating beneath. Text inside should be high-contrast and brief.
 */
export function HeroCard({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={
        'hero-glass relative overflow-hidden rounded-lg p-6 text-fg-inverse ' +
        (className ?? '')
      }
    >
      {children}
    </section>
  );
}
